// Links a la planilla del media plan, compartidos por la vista de propuesta y la de conexión.
// Vivían dentro de `MediaPlanProposalView` (2700 líneas) y ahora los necesitan las dos: el aviso
// que manda a la celda del problema y el selector de solapas, que abre cada solapa para poder
// verificarla antes de elegirla.

export function cellUrl(fileExternalId, evidence) {
    if (!fileExternalId || !evidence || !evidence.gid) return null;
    const range = evidence.cell ? `&range=${encodeURIComponent(evidence.cell)}` : '';
    return `https://docs.google.com/spreadsheets/d/${fileExternalId}/edit#gid=${evidence.gid}${range}`;
}

// URL a la planilla que degrada con gracia: a la celda/solapa si el aviso trae evidencia,
// sino al archivo (para bloqueos sin celda puntual, como la plataforma no soportada) — así el
// aviso deja de ser un callejón sin salida y el usuario puede ir a mirar la fila en cuestión.
export function spreadsheetUrl(fileExternalId, evidence) {
    if (!fileExternalId) return null;
    return cellUrl(fileExternalId, evidence)
        || `https://docs.google.com/spreadsheets/d/${fileExternalId}/edit`;
}

// URL a UNA solapa concreta (sin celda). El gid 0 es válido (la primera solapa de toda planilla),
// así que la comparación es contra null/undefined y no un chequeo de verdad.
export function tabUrl(fileExternalId, gid) {
    if (!fileExternalId) return null;
    if (gid === null || gid === undefined) {
        return `https://docs.google.com/spreadsheets/d/${fileExternalId}/edit`;
    }
    return `https://docs.google.com/spreadsheets/d/${fileExternalId}/edit#gid=${gid}`;
}
